export enum Interaction {
  CreateReservation = 'create-reservation',
  Checkout = 'checkout',
}
